<template>
<div class="chapter">
<div class="inner_page">
<p class="centera"><a id="page_ii"></a>ALSO BY DAVID LYNN GOLEMON</p>
<p class="centera"><em>Event<br/>Legend</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front.vue?42cf30e0